import { LOCALE_ID, NgModule } from '@angular/core';
import { CommonModule, DatePipe, registerLocaleData } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { LoginComponent } from './login/login.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CompanyPickerComponent } from './company-picker/company-picker.component';
import { UserFormComponent } from './user-form/user-form.component';
import { CalendarSettingsComponent } from './calendar-settings/calendar-settings.component';
import { SettingsComponent } from './settings/settings.component';
import { SignatureComponent } from './signature/signature.component';
import {
  CalendarEventFormComponent,
  CalendarManagementComponent,
  CalendarViewComponent,
  DateRangePickerComponent,
  FileTreeComponent,
  UploadComponent,
  ViewerComponent,
} from '../public-api';
import { PinchZoomComponent } from '@meddv/ngx-pinch-zoom';
import { UserOverviewComponent } from './user-overview/user-overview.component';
import { ConstructionSitePickerComponent } from './construction-site-picker/construction-site-picker.component';
import { DateTimePickerComponent } from './date-time-picker/date-time-picker.component';
import { MonthPickerComponent } from './month-picker/month-picker.component';
import { UserPickerComponent } from './user-picker/user-picker.component';
import localeDe from '@angular/common/locales/de';
import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { LoaderInterceptor } from './loader/loader.interceptor';
import { FilesComponent } from './files/files.component';
import { ContextMenuComponent } from './context-menu/context-menu.component';
import { MoveFolderComponent } from './move-folder/move-folder.component';
import { AbsenceDetailComponent } from './absence/absence-detail/absence-detail.component';
import { AbsenceOverviewComponent } from './absence/absence-overview/absence-overview.component';
import { AbsenceFormComponent } from './absence/absence-form/absence-form.component';
import { HoursDetailComponent } from './hours/hours-detail/hours-detail.component';
import { HoursFormComponent } from './hours/hours-form/hours-form.component';
import { HoursOverviewComponent } from './hours/hours-overview/hours-overview.component';
import { ConstructionDayReportDetailComponent } from './construction-day-report/construction-day-report-detail/construction-day-report-detail.component';
import { ConstructionDayReportFormComponent } from './construction-day-report/construction-day-report-form/construction-day-report-form.component';
import { ConstructionDayReportOverviewComponent } from './construction-day-report/construction-day-report-overview/construction-day-report-overview.component';
import { ViewerDialogComponent } from './viewer-dialog/viewer-dialog.component';
import { MachineDetailComponent } from './machinery/machine-detail/machine-detail.component';
import { MachineFormComponent } from './machinery/machine-form/machine-form.component';
import { MachineryOverviewComponent } from './machinery/machinery-overview/machinery-overview.component';
import { MachineOverviewComponent } from './machinery/machine-overview/machine-overview.component';
import { InspectionFormComponent } from './machinery/inspection-form/inspection-form.component';
import { InspectionOverviewComponent } from './machinery/inspection-overview/inspection-overview.component';
import { InspectionDetailComponent } from './machinery/inspection-detail/inspection-detail.component';
import { TableLegendComponent } from './table-legend/table-legend.component';
import { ConstructionSitesComponent } from './construction-sites/construction-sites.component';
import { ImagePreviewComponent } from './image-preview/image-preview.component';
import { HelpComponent } from './help/help.component';
import { ExportPopupComponent } from './export-popup/export-popup.component';
import { CalendarCommonModule } from 'angular-calendar';
import { MissingWorkEntryComponent } from './missing-work-entry/missing-work-entry.component';
import { UploadModalComponent } from './upload-modal/upload-modal.component';
import { CompanyFormComponent } from './company-form/company-form.component';
import { MachinePickerComponent } from './machine-picker/machine-picker.component';

registerLocaleData(localeDe);
@NgModule({
  declarations: [
    LoginComponent,
    CompanyPickerComponent,
    UserFormComponent,
    CalendarSettingsComponent,
    SettingsComponent,
    SignatureComponent,
    ViewerComponent,
    UserOverviewComponent,
    MonthPickerComponent,
    UserPickerComponent,
    DateTimePickerComponent,
    ConstructionSitePickerComponent,
    FilesComponent,
    ContextMenuComponent,
    UploadComponent,
    FileTreeComponent,
    MoveFolderComponent,
    CalendarViewComponent,
    CalendarEventFormComponent,
    CalendarManagementComponent,
    AbsenceDetailComponent,
    AbsenceOverviewComponent,
    AbsenceFormComponent,
    HoursDetailComponent,
    HoursFormComponent,
    ViewerDialogComponent,
    HoursOverviewComponent,
    ConstructionDayReportDetailComponent,
    ConstructionDayReportFormComponent,
    ConstructionDayReportOverviewComponent,
    MachineDetailComponent,
    MachineFormComponent,
    MachineryOverviewComponent,
    MachineOverviewComponent,
    InspectionFormComponent,
    InspectionOverviewComponent,
    InspectionDetailComponent,
    TableLegendComponent,
    ConstructionSitesComponent,
    ImagePreviewComponent,
    HelpComponent,
    ExportPopupComponent,
    DateRangePickerComponent,
    MissingWorkEntryComponent,
    UploadModalComponent,
    CompanyFormComponent,
    MachinePickerComponent,
  ],
  imports: [
    CommonModule,
    IonicModule,
    FormsModule,
    ReactiveFormsModule,
    PinchZoomComponent,
    CalendarCommonModule,
  ],
  providers: [
    DatePipe,
    { provide: LOCALE_ID, useValue: 'de-DE' },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: LoaderInterceptor,
      multi: true,
    },
  ],
  exports: [
    LoginComponent,
    CompanyPickerComponent,
    UserFormComponent,
    CalendarSettingsComponent,
    SettingsComponent,
    SignatureComponent,
    ViewerComponent,
    UserOverviewComponent,
    MonthPickerComponent,
    UserPickerComponent,
    ViewerDialogComponent,
    DateTimePickerComponent,
    ConstructionSitePickerComponent,
    FilesComponent,
    ContextMenuComponent,
    UploadComponent,
    MoveFolderComponent,
    FileTreeComponent,
    CalendarViewComponent,
    CalendarEventFormComponent,
    CalendarManagementComponent,
    AbsenceDetailComponent,
    AbsenceOverviewComponent,
    AbsenceFormComponent,
    HoursDetailComponent,
    HoursFormComponent,
    HoursOverviewComponent,
    ConstructionDayReportDetailComponent,
    ConstructionDayReportFormComponent,
    ConstructionDayReportOverviewComponent,
    MachineDetailComponent,
    MachineFormComponent,
    MachineryOverviewComponent,
    MachineOverviewComponent,
    InspectionFormComponent,
    InspectionOverviewComponent,
    InspectionDetailComponent,
    TableLegendComponent,
    ConstructionSitesComponent,
    HelpComponent,
    ExportPopupComponent,
    DateRangePickerComponent,
    MissingWorkEntryComponent,
    UploadModalComponent,
    CompanyFormComponent,
    MachinePickerComponent,
  ],
})
export class SharedModule {}
